import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from "@emotion/styled";
import { useElementsContext } from "../elementsProvider";
import { Fragment } from "react";
import { itemSkin2Style, itemImageSize, itemSkin1Width } from "./utils";
import { colors } from "../theme";
export function RTCFeaturedCard({ skin, subelements, typographyTexts, }) {
    const { isMobile } = useElementsContext();
    const items = subelements.length.toString();
    return (_jsx(Container, Object.assign({ skin: skin, items: items, isDesktop: !isMobile }, { children: subelements.map(subelement => {
            const images = JSON.parse(subelement.image);
            return (_jsx(UrlWrapper, Object.assign({ href: subelement.url }, { children: _jsx(CardContainer, Object.assign({ skin: skin, items: items, isDesktop: !isMobile }, { children: _jsxs(Fragment, { children: [_jsx(Image, { items: items, skin: skin, src: isMobile ? images.medium : images[itemImageSize[items]], alt: "Imagen", isDesktop: !isMobile }, void 0),
                            _jsxs(TextContainer, Object.assign({ items: items, skin: skin, isDesktop: !isMobile }, { children: [_jsx(Text, Object.assign({ typographyTexts: typographyTexts, skin: skin, items: items, isDesktop: !isMobile }, { children: subelement.text }), void 0),
                                    _jsx(Title, Object.assign({ typographyTexts: typographyTexts, skin: skin, items: items, isDesktop: !isMobile }, { children: subelement.title }), void 0)] }), void 0)] }, void 0) }), void 0) }), subelement.identifier));
        }) }), void 0));
}
function UrlWrapper({ href, children }) {
    if (href !== "") {
        return _jsx(Link, Object.assign({ href: href }, { children: children }), void 0);
    }
    return children;
}
const Container = styled.section(({ skin, items, isDesktop }) => {
    let gridGap;
    switch (skin) {
        case "2":
            gridGap = items === "2" ? "1.6rem" : "0.8rem";
            break;
        default:
            // skin 1
            gridGap = "1.6rem";
            break;
    }
    return Object.assign({ display: "grid", gridGap: skin === "1" ? "1.6rem" : "0.8rem", width: "100%" }, (isDesktop
        ? {
            alignItems: "center",
            gridAutoFlow: "column",
            gridGap: gridGap,
            justifyContent: "center",
        }
        : {}));
});
const CardContainer = styled.article(({ skin, items, isDesktop }) => {
    let display;
    let gridTemplateRowDesktop;
    let gridTemplateRows;
    let height;
    let width;
    switch (skin) {
        case "2":
            display = "";
            gridTemplateRows = "1fr";
            height = itemSkin2Style[items].height;
            width = items !== "1" ? itemSkin2Style[items].height : "94rem";
            break;
        default:
            // skin 1
            display = "grid";
            gridTemplateRowDesktop = items === "1" ? "20rem 7.2rem" : "";
            gridTemplateRows = "18.8rem 7.2rem";
            height = "100%";
            width = itemSkin1Width[items];
            break;
    }
    return Object.assign({ backgroundColor: colors.white, display: display, gridTemplateRows: gridTemplateRows, height: skin === "2" ? "28.8rem" : "", position: "relative", textAlign: "left", width: "100%" }, (isDesktop
        ? {
            gridTemplateRows: gridTemplateRowDesktop,
            height: height,
            width: width,
            "&:hover": {
                boxShadow: "0px 6px 12px 0px rgba(0,0,0,0.2)",
            },
        }
        : {}));
});
const TextContainer = styled.div(({ skin, items, isDesktop }) => (Object.assign({ backgroundColor: skin === "1" ? colors.white : "", backgroundImage: skin === "2"
        ? "linear-gradient(to top, rgba(1, 1, 1, 0.74), rgba(0, 0, 0, 0.3) 63%, rgba(0, 0, 0, 0.08) 80%, rgba(0, 0, 0, 0))"
        : "", bottom: skin === "2" ? 0 : "", boxShadow: skin === "1" ? "0 2px 4px 0 rgba(0, 0, 0, 0.2)" : "", height: skin === "1" ? "7.2rem" : "8.8rem", padding: "1.6rem 0.8rem", position: skin === "1" ? "relative" : "absolute", width: "100%" }, (isDesktop
    ? {
        height: skin === "1" ? "7.2rem" : itemSkin2Style[items].opacityLayerHeight,
    }
    : {}))));
const Title = styled.h2(({ skin, typographyTexts, items, isDesktop }) => (Object.assign({ bottom: skin === "2" ? "3.6rem" : "1.2rem", color: skin === "1" ? colors.black : colors.white, fontFamily: typographyTexts, fontSize: skin === "1" ? "2rem" : "2.4rem", left: skin === "2" ? "0.8rem" : "", margin: 0, position: "absolute" }, (isDesktop
    ? {
        bottom: skin === "2" ? itemSkin2Style[items].bottom.title : "1.2rem",
        fontSize: skin === "1" ? "2rem" : itemSkin2Style[items].fontSize.title,
        left: skin === "2" ? itemSkin2Style[items].left : "",
    }
    : {}))));
const Text = styled.p(({ typographyTexts, skin, items, isDesktop }) => (Object.assign({ bottom: skin === "2" ? "1.6rem" : "", color: skin === "1" ? colors.black : colors.white, fontFamily: typographyTexts, fontSize: skin === "1" ? "1.2rem" : "1.4rem", left: skin === "2" ? "0.8rem" : "", margin: 0, position: skin === "1" ? "relative" : "absolute" }, (isDesktop
    ? {
        bottom: skin === "2" ? itemSkin2Style[items].bottom.text : "",
        fontSize: skin === "1" ? "1.2rem" : itemSkin2Style[items].fontSize.text,
        left: skin === "2" ? itemSkin2Style[items].left : "",
    }
    : {}))));
const Image = styled.img(({ isDesktop, items, skin }) => (Object.assign({ height: skin === "1" ? (isDesktop && items === "1" ? "20rem" : "18.8rem") : "100%", objectFit: "cover", width: "100%" }, (isDesktop
    ? {
        gridRow: skin === "2" ? 1 : "",
    }
    : {}))));
const Link = styled.a(() => ({
    height: "100%",
    textDecoration: "none",
    width: "100%",
}));
//# sourceMappingURL=RTCFeaturedCard.js.map